<template>
  <div class="ai-check-container">
    <!-- Header Banner -->
    <div class="ai-header-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <div class="banner-left">
          <div class="ai-icon-pulse">
            <i class="el-icon-link"></i>
          </div>
          <div>
            <h1 class="banner-title">DANH SÁCH NGÂN HÀNG LIÊN KẾT TRƯỜNG</h1>
            <p class="banner-subtitle">Quản lý tài khoản ngân hàng nhà trường liên kết qua cổng SePay, đối soát dòng tiền và trạng thái công nợ.</p>
          </div>
        </div>
        <div class="banner-actions">
          <el-button type="success" class="gradient-btn green-btn" icon="el-icon-plus" @click="handleOpenAddAccountBankToBrandDialog">
            Thêm tài khoản có sẵn
          </el-button>
        </div>
      </div>
    </div>

    <!-- Quick Stats Grid -->
    <div class="ai-stats-grid">
      <div class="stat-card blue">
        <div class="stat-icon"><i class="el-icon-bank"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng tài khoản liên kết</p>
          <h3 class="stat-value">{{ totalPage }}</h3>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
        <div class="stat-info">
          <p class="stat-label">Liên kết thành công (trang này)</p>
          <h3 class="stat-value">{{ stats.connectedCount }}</h3>
        </div>
      </div>
      <div class="stat-card purple">
        <div class="stat-icon"><i class="el-icon-refresh"></i></div>
        <div class="stat-info">
          <p class="stat-label">Đã xác thực OTP (trang này)</p>
          <h3 class="stat-value">{{ stats.otpCount }}</h3>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="glass-card mb-4">
      <el-form :inline="true" :model="dataSearch" class="modern-filter-form">
        <el-form-item label="Trường học">
          <el-select
            v-model="dataSearch.idSchool"
            filterable
            clearable
            placeholder="Tất cả các trường"
            class="modern-select"
            @change="findAllData"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :value="item.id"
              :label="`${item.id} - ${item.schoolName}`"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Liên kết API">
          <el-select
            v-model="dataSearch.statusBankApiConnected"
            clearable
            placeholder="Tất cả trạng thái"
            class="modern-select"
            @change="findAllData"
          >
            <el-option
              v-for="item in listStatusBankApiConnected"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Công nợ">
          <el-select
            v-model="dataSearch.statusBillPayment"
            clearable
            placeholder="Trạng thái công nợ"
            class="modern-select"
            @change="findAllData"
          >
            <el-option
              v-for="item in listStatusBillPayment"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Trạng thái xóa">
          <el-select
            v-model="dataSearch.delActive"
            placeholder="Trạng thái xóa"
            class="modern-select"
            @change="findAllData"
          >
            <el-option
              v-for="item in listActive"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Số tài khoản">
          <el-input
            v-model="dataSearch.accountNumber"
            clearable
            placeholder="Nhập số tài khoản..."
            class="modern-input"
            prefix-icon="el-icon-search"
            @keyup.enter.native="findAllData"
            @clear="findAllData"
          />
        </el-form-item>

        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="findAllData">Lọc dữ liệu</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Table Section -->
    <div class="glass-card table-container">
      <el-table
        ref="multipleTable"
        :data="dataTable"
        v-loading="loading.table"
        element-loading-text="Đang tải danh sách tài khoản liên kết..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.7)"
        class="modern-table"
        border
        highlight-current-row
        @selection-change="handleSelectionChange"
        :max-height="tableMaxHeight"
      >
        <el-table-column type="selection" width="55" align="center" />
        
        <el-table-column type="index" :index="calculateStt" label="STT" width="55" align="center" />

        <el-table-column label="Tên trường học" min-width="240" prop="schoolName" fixed>
          <template slot-scope="{ row }">
            <span class="school-name-text">
              <i class="el-icon-school" style="color: #64748b; margin-right: 4px;"></i>
              {{ row.schoolName }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="Đại lý quản lý" min-width="180" prop="companyName">
          <template slot-scope="{ row }">
            <span class="brand-full-name">{{ row.companyName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Thông số ID SePay" min-width="180" align="center">
          <template slot-scope="{ row }">
            <div class="id-sepay-block">
              <span class="sub-label">Đại lý:</span> <code class="code-badge">{{ row.xidCompany }}</code>
              <span class="sub-label mt-1">Ngân hàng:</span> <code class="code-badge">{{ row.xidBankAccount }}</code>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Chủ tài khoản" min-width="200" prop="accountHolderName">
          <template slot-scope="{ row }">
            <span class="holder-name">{{ row.accountHolderName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Thông tin tài khoản" min-width="220">
          <template slot-scope="{ row }">
            <div class="account-info-block">
              <span class="account-num">{{ row.accountNumber }}</span>
              <span class="bank-tag">{{ row.bankName }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Tên gợi nhớ" min-width="160" prop="label">
          <template slot-scope="{ row }">
            <span class="label-text">{{ row.label || '—' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Hiển thị QR" width="110" align="center" prop="showQR">
          <template slot-scope="{ row }">
            <el-checkbox
              v-model="row.showQR"
              @change="handleChangeShow(row)"
              :disabled="!row.bankApiConnected || !row.authenticationOTP"
            />
          </template>
        </el-table-column>

        <el-table-column label="Ưu tiên" width="90" align="center" prop="priority" />

        <el-table-column label="Sử dụng TK ảo nhận biến động SD" width="200" align="center" prop="showQR">
          <template slot-scope="{ row }">
            <el-checkbox
                v-model="row.useVASynchronization"
                @change="handleChangeUpdateUseVASynchronization(row)"
            />
          </template>
        </el-table-column>

        <el-table-column label="Số tài khoản ảo" width="150" align="center">
          <template slot-scope="{ row }">
            <span
              v-if="row.seAccountVADtos && row.seAccountVADtos.length > 0"
              class="va-badge-clickable"
              @click="handleClickFindListVA(row)"
            >
              {{ row.seAccountVADtos.length }}
            </span>
            <span v-else class="text-muted">0</span>
          </template>
        </el-table-column>

        <el-table-column label="Giao dịch trong tháng" min-width="220" align="right">
          <template slot-scope="{ row }">
            <div class="money-stats">
              <div class="money-row green-text">
                <span class="m-label">Tổng tiền vào:</span>
                <span class="m-val">{{ row.sumMoneyIn | formatCurrency }}</span>
              </div>
              <div class="money-row red-text mt-1">
                <span class="m-label">Tổng tiền ra:</span>
                <span class="m-val">{{ row.sumMoneyOut | formatCurrency }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Kết nối API" width="160" align="center" prop="bankApiConnected">
          <template slot-scope="{ row }">
            <span class="status-badge" :class="row.bankApiConnected ? 'online' : 'offline'">
              <span class="dot"></span>
              {{ row.bankApiConnected ? 'Đã liên kết' : 'Chưa liên kết' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="Xác thực OTP" width="160" align="center" prop="authenticationOTP">
          <template slot-scope="{ row }">
            <span class="status-badge" :class="row.authenticationOTP ? 'online' : 'offline'">
              <span class="dot"></span>
              {{ row.authenticationOTP ? 'Đã xác thực' : 'Chưa xác thực' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="Hoàn thành công nợ" width="160" align="center" prop="billPaymentStatus">
          <template slot-scope="{ row }">
            <el-checkbox v-model="row.billPaymentStatus" disabled />
          </template>
        </el-table-column>

        <el-table-column label="GD cuối" min-width="180" prop="lastTransaction" align="center">
          <template slot-scope="{ row }">
            <span class="date-time-text">{{ row.lastTransaction || '—' }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination controls -->
      <div class="pagination-wrapper mt-3 flex justify-center">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentPageChange"
          :current-page.sync="dataSearch.page"
          :page-sizes="listSizePage"
          :page-size="dataSearch.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </div>
    </div>

    <!-- Dialogs -->
    <UnConnectionBanksDialog
      :showUnConnectionBanksDialog="showUnConnectionBanksDialog"
      :request_id="request_id"
      :bank="bank"
      @closeDialog="closeUnConnectionBanksDialog"
    />
    <AccountVADialog
      :showQRMainAccount="showQRMainAccount"
      :showAccountVADialog="showAccountVADialog"
      :listVA="listVA"
      :bank="bank"
      :actionToAdmin="actionToAdmin"
      @closeDialog="handleCloseAccountVADialog"
    />
    <AddAccountBankToBrandDialog
      :isOpenAddAccountBankToBrandDialog="isOpenAddAccountBankToBrandDialog"
      @closeDialog="handleCloseAddAccountBankToBrandDialog"
    />
  </div>
</template>

<script>
import SystemConfigService from "@/services/AdminService/SystemConfigService";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import UnConnectionBanksDialog from "@/views/sepay/dialog/UnConnectionBanksDialog.vue";
import AccountVADialog from "@/views/sepay/dialog/AccountVADialog.vue";
import AddAccountBankToBrandDialog from "@/views/sepay/dialog/AddAccountBankToBrandDialog.vue";

export default {
  name: "LinkedSchoolBankAccount",
  components: { AddAccountBankToBrandDialog, AccountVADialog, UnConnectionBanksDialog },
  data() {
    return {
      dataTable: [],
      loading: {
        table: false
      },
      schoolList: [],
      dataSearch: {
        delActive: true,
        idSchool: "",
        statusBankApiConnected: null,
        statusBillPayment: null,
        accountNumber: "",
        page: 1,
        limit: 10
      },
      listSizePage: [10, 30, 40, 50, 100, 200, 500],
      totalPage: 0,
      listStatusBankApiConnected: [
        { value: true, label: "Đã liên kết" },
        { value: false, label: "Chưa liên kết" }
      ],
      listStatusBillPayment: [
        { value: true, label: "Đã hoàn thành" },
        { value: false, label: "Chưa hoàn thành" }
      ],
      listActive: [
        { value: true, label: "Chưa xóa" },
        { value: false, label: "Đã xóa" }
      ],
      showUnConnectionBanksDialog: false,
      Thêm: false,
      request_id: "",
      bank: {},
      showQRMainAccount: false,
      showAccountVADialog: false,
      listVA: [],
      actionToAdmin: true,
      listBrand: []
    };
  },

  computed: {
    tableMaxHeight() {
      return this.$tableMaxHeightCardManager || 750;
    },

    stats() {
      let connectedCount = 0;
      let otpCount = 0;
      this.dataTable.forEach(x => {
        if (x.bankApiConnected) connectedCount++;
        if (x.authenticationOTP) otpCount++;
      });
      return { connectedCount, otpCount };
    }
  },

  created() {
    this.findAllAppIconForSchool();
    this.findAllData();
  },

  methods: {
    async findAllData() {
      this.loading.table = true;
      let idSchoolResponse = null;
      if (this.dataSearch.idSchool !== "" && this.dataSearch.idSchool !== undefined) {
        idSchoolResponse = Number(this.dataSearch.idSchool);
      }
      try {
        const response = await sePayConnectionService.findAllDataByAdmin(
          this.dataSearch.delActive,
          this.dataSearch.accountNumber,
          idSchoolResponse,
          this.dataSearch.statusBankApiConnected,
          this.dataSearch.statusBillPayment,
          this.dataSearch.limit,
          this.dataSearch.page
        );
        this.dataTable = response.data.data.sePayBankAccountList || [];
        this.totalPage = response.data.data.total || 0;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading.table = false;
      }
    },

    async findAllAppIconForSchool() {
      try {
        const resp = await SystemConfigService.findSchoolConfig("", this.dataSearch.idSchool, true);
        if (this.dataSearch.idSchool === "") {
          this.schoolList = resp.data.data || [];
        }
      } catch (err) {
        console.error(err);
      }
    },

    handleSelectionChange(value) {
      this.listBrand = value.map(item => item.id.toString());
    },

    async handleChangeShow(row) {
      try {
        const response = await sePayConnectionService.showQRBanksAdmin(row.id, row.idSchool, row.showQR);
        if (response.data.data === true) {
          NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!");
        } else {
          NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!");
        }
        await this.findAllData();
      } catch (err) {
        console.error(err);
      }
    },

    async handleChangeUpdateUseVASynchronization(row){
      try {
        const response = await sePayConnectionService.updateUseVASynchronization(row.id, row.useVASynchronization);
        if (response.data.data === true) {
          NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!");
        } else {
          NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!");
        }
        await this.findAllData();
      } catch (err) {
        console.error(err);
      }
    },

    handleCommand(command) {
      if (command === "addAccountToBrand") {
        this.handleOpenAddAccountBankToBrandDialog();
      }
    },

    handleSizeChange(value) {
      this.dataSearch.limit = value;
      this.dataSearch.page = 1;
      this.findAllData();
    },

    handleCurrentPageChange(value) {
      this.dataSearch.page = value;
      this.findAllData();
    },

    calculateStt(index) {
      return (this.dataSearch.page - 1) * this.dataSearch.limit + index + 1;
    },

    handleOpenAddAccountBankToBrandDialog() {
      this.isOpenAddAccountBankToBrandDialog = true;
    },

    closeUnConnectionBanksDialog() {
      this.showUnConnectionBanksDialog = false;
      this.findAllData();
    },

    handleCloseAccountVADialog() {
      this.showAccountVADialog = false;
      this.findAllData();
    },

    handleCloseAddAccountBankToBrandDialog() {
      this.isOpenAddAccountBankToBrandDialog = false;
      this.findAllData();
    },

    handleClickFindListVA(row) {
      this.showQRMainAccount = row.showQR;
      this.bank = row;
      this.listVA = row.seAccountVADtos || [];
      this.showAccountVADialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-container {
  padding: 16px;
  background-color: #f4f6fa;
  min-height: calc(100vh - 120px);
}

/* Header Banner Styling */
.ai-header-banner {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 32px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.15);

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  }

  .banner-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    width: 100%;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .ai-icon-pulse {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    animation: iconPulse 3s infinite ease-in-out;

    i {
      font-size: 32px;
      color: #fff;
    }
  }

  .banner-title {
    color: #fff;
    font-size: 22px;
    margin: 0 0 6px 0;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .banner-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    margin: 0;
  }

  .gradient-btn {
    border: none;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
    }

    &.green-btn {
      background: linear-gradient(90deg, #10b981 0%, #059669 100%);
      box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4); }
    }
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  }
}

/* Stats Cards Grid */
.ai-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .stat-info {
    flex: 1;
  }

  .stat-label {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: #64748b;
  }

  .stat-value {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
  }

  /* Colors */
  &.blue {
    border-left: 4px solid #3b82f6;
    .stat-icon { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
  }
  &.green {
    border-left: 4px solid #10b981;
    .stat-icon { background: rgba(16, 185, 129, 0.1); color: #10b981; }
  }
  &.purple {
    border-left: 4px solid #8b5cf6;
    .stat-icon { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }
  }
}

/* Glassmorphic Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.table-container {
  background: #fff;
  padding: 12px;
}

/* Filter Forms */
.modern-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  .modern-select {
    width: 180px;
  }

  .modern-input {
    width: 220px;
  }
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 8px 0;
  }
}

.school-name-text {
  font-weight: 700;
  color: #1e3c72;
}

.brand-full-name {
  font-weight: 600;
  color: #475569;
}

.id-sepay-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .sub-label {
    font-size: 11px;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
  }
}

.code-badge {
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: Consolas, Monaco, monospace;
  font-size: 11px;
  color: #475569;
  border: 1px solid #cbd5e1;
}

.holder-name {
  font-weight: 700;
  color: #1e293b;
  text-transform: uppercase;
  font-size: 13px;
}

.account-info-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  .account-num {
    font-family: Consolas, Monaco, monospace;
    font-weight: 700;
    color: #2563eb;
    font-size: 14px;
  }

  .bank-tag {
    background-color: #f1f5f9;
    border: 1px solid #cbd5e1;
    color: #475569;
    font-size: 11px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 4px;
  }
}

.label-text {
  font-weight: 600;
  color: #64748b;
  font-size: 13px;
}

.money-stats {
  display: flex;
  flex-direction: column;

  .money-row {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 600;

    .m-label {
      color: #94a3b8;
      font-size: 11px;
    }
  }

  .green-text .m-val {
    color: #166534;
  }

  .red-text .m-val {
    color: #991b1b;
  }
}

.date-time-text {
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

/* Status Badge */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 9999px;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &.online {
    background-color: #f0fdf4;
    color: #166534;
    .dot {
      background-color: #22c55e;
    }
  }

  &.offline {
    background-color: #fef2f2;
    color: #991b1b;
    .dot {
      background-color: #ef4444;
    }
  }
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.mt-1 { margin-top: 4px; }

.va-badge-clickable {
  background: #eff6ff;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  font-weight: 700;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: inline-block;

  &:hover {
    background: #dbeafe;
    color: #1e40af;
    transform: scale(1.02);
  }
}

.text-muted {
  color: #94a3b8;
}
</style>